import img1 from "../Assets/Images/1.jpg";
import img2 from "../Assets/Images/2.jpg";
import img3 from "../Assets/Images/3.jpg";
import img4 from "../Assets/Images/4.jpg";
import img5 from "../Assets/Images/5.jpg";
import img6 from "../Assets/Images/6.jpg";
import img7 from "../Assets/Images/7.jpg";
import img8 from "../Assets/Images/8.jpg";

export const UpcomingActivitiesData = [
  {
    id: 1,
    img: img1,
    date: "15",
    month: "May",
    price: 45000,
    detail: "2 Days and 1 Night Camping and Paragliding in Khanspur.",
    path: "/demo",
  },
  {
    id: 2,
    img: img2,
    date: "28",
    month: "May",
    price: 60000,
    detail: "5 Days and 4 Nights Camping and Hiking in Babusar Top.",
    path: "/demo",
  },
  {
    id: 3,
    img: img3,
    date: "06",
    month: "June",
    price: 30000,
    detail: "3 Days and 2Night Trekking in Abbottabad",
    path: "/demo",
  },
  {
    id: 4,
    img: img4,
    date: "26",
    month: "June",
    price: 45000,
    detail: "2 Days and 1 Nights Mountain Biking in Khanpur Lake Periphery",
    path: "/demo",
  },
  {
    id: 5,
    img: img5,
    date: "03",
    month: "July",
    price: 90000,
    detail:
      "7 Days and 6 Nights Camping and Hiking in Islamabad, Murree, and Kallar Kahar",
    path: "/demo",
  },
  {
    id: 6,
    img: img6,
    date: "22",
    month: "July",
    price: 35000,
    detail: "2 Days and 1 Nights Biking in Khanspur",
    path: "/demo",
  },
  {
    id: 7,
    img: img7,
    date: "11",
    month: "Aug",
    price: 55000,
    detail: "3 Days and 2 Nights River Rafting in Chitral,Swat",
    path: "/demo",
  },
  {
    id: 8,
    img: img8,
    date: "21",
    month: "Aug",
    price: 126000,
    detail: "7 Days and 6 Night Camping and Paragliding in Chitral",
    path: "/demo",
  },
];
